import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DataEntity} from "octopus-connect";
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {Observable} from "rxjs";
import {AsyncPipe} from "@angular/common";
import {DataStepOne} from "fuse-core/components/first-time-user-experience/first-time-user-experience.component";
import {
    FilterEducationalLevelsPipe
} from "fuse-core/components/first-time-user-experience/filter-educational-levels.pipe";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-first-time-user-experience-step-one',
    imports: [
        MatChipsModule,
        MatIconModule,
        AsyncPipe,
        FilterEducationalLevelsPipe,
        TranslateModule
    ],
    templateUrl: './first-time-user-experience-step-one.component.html',
    styleUrl: './first-time-user-experience-step-one.component.scss'
})
export class FirstTimeUserExperienceStepOneComponent {
    @Output() nextEmitter: EventEmitter<DataStepOne> = new EventEmitter();
    @Output() closeEmitter: EventEmitter<boolean> = new EventEmitter();
    @Input() educationalLevels$: Observable<DataEntity[]>;
    @Input() userData:DataEntity;

    public displayStepInterval = false;
    public selectedEducationalLevels: DataEntity[] | null = [];
    public educationalLevelStarter: DataEntity;
    onNext() {
        if (!this.displayStepInterval && this.selectedEducationalLevels.length > 1) {
            this.displayStepInterval = true;
        } else {
            if (!this.educationalLevelStarter) {
                this.educationalLevelStarter = this.selectedEducationalLevels[0]; // Default to the first selected educational level if none is specified
            }
            const DataStepOne: DataStepOne = {
                educationalLevels: this.selectedEducationalLevels,
                educationalLevelStarter: this.educationalLevelStarter
            };
            this.nextEmitter.emit(DataStepOne);
            // Logic to proceed to the next step
        }
    }

    onClose() {
        this.closeEmitter.emit(true);
        // Logic to close the first-time user experience
    }

    selectEducationalLevel(level: DataEntity) {
        if (this.selectedEducationalLevels.find(selected => selected.id === level.id)) {
            // If the level is already selected, remove it
            this.selectedEducationalLevels = this.selectedEducationalLevels.filter(selected => selected.id !== level.id);
        } else {
            this.selectedEducationalLevels.push(level);
        }
    }

    selectEducationalLevelStarter(level: DataEntity) {
        this.educationalLevelStarter = level;
    }
}
